/**
 * Dev-host detection.
 *
 * `npm run dev` binds 0.0.0.0, so the CRA dev server is also reachable from
 * other devices on the LAN (phone testing) at a private IP like 192.168.1.42
 * or an mDNS name like my-laptop.local. Those hosts must behave exactly like
 * localhost: the app shows the email/password LoginForm instead of bouncing
 * the visitor into Thinkific OAuth (which only works from the deployed origin).
 */

// 10/8, 127/8, 169.254/16 (link-local), 172.16/12, 192.168/16,
// plus 100.64/10 (CGNAT — what Tailscale hands out)
const PRIVATE_IPV4 = /^(10\.|127\.|169\.254\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.|100\.(6[4-9]|[7-9]\d|1[01]\d|12[0-7])\.)/;

/**
 * True when the app is being served from a local development host.
 * @param {string} [hostname] - defaults to the current window hostname
 */
export function isDevHost(hostname = window.location.hostname) {
  const host = (hostname || '').toLowerCase();

  if (host === 'localhost' || host.endsWith('.localhost')) return true;
  if (host === '::1' || host === '[::1]') return true;
  if (host.endsWith('.local') || host.endsWith('.lan') || host.endsWith('.ts.net')) return true;

  return PRIVATE_IPV4.test(host);
}
